import { Application } from '@hotwired/stimulus';
import ComboboxController from './combobox_controller.js';
import TabsController from './tabs_controller.js';
import CartController from './cart_controller.js';
import LeadTableController from './lead_table_controller.js';
import LeadListController from './lead_list_controller.js';
import OrdersController from './orders_controller.js';
import ComplaintsController from './complaints_controller.js';
import CreditsController from './credits_controller.js';
import PackagePickerController from './package_picker_controller.js';
import BackorderController from './backorder_controller.js';
import AuthLogController from './auth_log_controller.js';
import PhoneVerifyController from './phone_verify_controller.js';
import AccountController from './account_controller.js';
import MarketingConsentController from './marketing_consent_controller.js';
import DataTableController from './data_table_controller.js';
import HelpdeskController from './helpdesk_controller.js';
import WalletBalanceController from './wallet_balance_controller.js';
import DismissController from './dismiss_controller.js'
import SubcatSearchController from './subcat_search_controller.js';
import ContactFormController from './contact_form_controller.js';
import FavoriteHeartController from './favorite_heart_controller.js';
import NotificationsController from './notifications_controller.js';
import NotificationBadgeController from './notification_badge_controller.js';
import SettingsShellController from './settings_shell_controller.js';
import OrgSwitcherController from './org_switcher_controller.js';
import DemandController from './demand_controller.js';
import VerificationController from './verification_controller.js';
import PaymentReturnController from './payment_return_controller.js';
import PaymentsController from './payments_controller.js';
import TopnavController from './topnav_controller.js';
import NavDropdownController from './nav_dropdown_controller.js';
import LlFiltersController from './ll_filters_controller.js';
import TutorialController from './tutorial_controller.js';

const application = Application.start();
application.register('combobox', ComboboxController);
application.register('tabs', TabsController);
application.register('cart', CartController);
application.register('lead-table', LeadTableController);
application.register('lead-list', LeadListController);
application.register('orders', OrdersController);
application.register('complaints', ComplaintsController);
application.register('credits', CreditsController);
application.register('package-picker', PackagePickerController);
application.register('backorder', BackorderController);
application.register('auth-log', AuthLogController);
application.register('phone-verify', PhoneVerifyController);
application.register('account', AccountController);
application.register('marketing-consent', MarketingConsentController);
application.register('data-table', DataTableController);
application.register('helpdesk', HelpdeskController);
application.register('wallet-balance', WalletBalanceController);
application.register('dismiss', DismissController);
application.register('subcat-search', SubcatSearchController);
application.register('contact-form', ContactFormController);
application.register('favorite-heart', FavoriteHeartController);
application.register('notifications', NotificationsController);
application.register('notification-badge', NotificationBadgeController);
application.register('settings-shell', SettingsShellController);
application.register('org-switcher', OrgSwitcherController);
application.register('demand', DemandController);
application.register('verification', VerificationController);
application.register('payment-return', PaymentReturnController);
application.register('payments', PaymentsController);
application.register('topnav', TopnavController);
application.register('nav-dropdown', NavDropdownController);
application.register('ll-filters', LlFiltersController);
application.register('tutorial', TutorialController);

export { application };
